<template>
	<div>
		<Form />
		<Footer />
	</div>
</template>

<script>

import Form from './Form.vue'
import Footer from '../../components/Footer.vue'

export default {
	name: 'Index',
	components: {Form , Footer },
	created: function() {
	}
}
</script>
